import { z } from 'zod';

const appEnvironments = ['development', 'demo', 'production'] as const;

const clientEnvSchema = z
  .object({
    VITE_APP_ENV: z.enum(appEnvironments).default('development'),
    VITE_SUPABASE_URL: z.string().url().optional(),
    VITE_SUPABASE_PUBLISHABLE_KEY: z.string().min(1).optional(),
    // Tests et démonstration hors ligne : les fonctions IA rendent une
    // proposition déterministe sans appel OpenAI.
    VITE_ALBA_AI_FIXTURE: z.enum(['true', 'false']).optional(),
  })
  .superRefine((environment, context) => {
    const hasUrl = Boolean(environment.VITE_SUPABASE_URL);
    const hasKey = Boolean(environment.VITE_SUPABASE_PUBLISHABLE_KEY);

    if (hasUrl !== hasKey) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        message:
          'VITE_SUPABASE_URL et VITE_SUPABASE_PUBLISHABLE_KEY doivent être définies ensemble.',
      });
    }
  });

export type ClientEnvironment = z.infer<typeof clientEnvSchema>;

export function parseClientEnvironment(environment: Record<string, unknown>): ClientEnvironment {
  return clientEnvSchema.parse(environment);
}

export const clientEnvironment = parseClientEnvironment(import.meta.env);
